import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserLogin} from '../../models/UserLogin';
import {UserService} from '../../services/user.service';
import {AccountService} from '../../services/account.service';
import {ErrorHandlerService} from '../../services/error-handler.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {AlertService} from '../../shared/services/alert.service';
import * as Constants from '../../models/Constants';
import {ErisLoginService} from '../../services/sso/eris-login.service';
import userdata from '../../services/sso/user_data';
import {take} from 'rxjs/operators';
import {User} from 'oidc-client';

const REASON_MESSAGES: { [reason: string]: string } = {
  'signed-out': 'You have been signed out.',
  unauthorized: 'Your session has ended.',
  'callback-failed': 'Sign-in could not be completed.'
};

@Component({
  selector: 'login',
  templateUrl: 'login.template.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit, OnDestroy {
  public justSignedUp = false;
  /** When set, the page waits for the user to click "Sign in" instead of redirecting to the STS straight away. */
  public signedOutMessage = '';
  public userLogin = new UserLogin();
  public errorMsg = '';
  public user = '';

  constructor(private userService: UserService, private router: Router, private accountService: AccountService,
              private activatedRoute: ActivatedRoute, private errorHandlerService: ErrorHandlerService,
              private spinner: NgxSpinnerService, private alertService: AlertService, private erisLoginService: ErisLoginService) {
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.paramMap.get('justSignedUp')) {
      this.alertService.success('You have successfully registered, you can login now');
    }

    const reason = this.activatedRoute.snapshot.queryParamMap.get('reason');
    if (reason) {
      // After a sign-out or a rejected token, redirecting straight back to the STS would race the
      // sign-out redirect or loop; wait for the user to click "Sign in".
      this.signedOutMessage = REASON_MESSAGES[reason] || 'Please sign in to continue.';
      return;
    }

    this.erisLoginService.getUser().pipe(take(1)).subscribe(
      user => {
        if (user instanceof User && !user.expired) {
          void this.router.navigateByUrl('/');
          return;
        }
        void this.login();
      },
      error => {
        console.log('User not found');
        console.log(error);
        void this.login();
      }
    );
  }

  public async login() {
    this.spinner.show();
    await this.erisLoginService.login();
  }

  ngOnDestroy(): void {
    this.justSignedUp = false;
  }

  async initiateLogin(): Promise<any> {
    await this.erisLoginService.login();
  }

  async getUser(): Promise<any> {
    try {
      const user = await this.erisLoginService.getUser().pipe(take(1)).toPromise();
      this.user = JSON.stringify(user);
    } catch (e) {
      console.log(e);
      console.error(e);
    }
  }
}
